import { createSelector } from 'reselect';
import utils from 'utils';
import { pickupLocationLocalAddendaPath } from 'paths/reservationLocation';
import { skipTheCounterOriginPath } from 'paths/skipTheCounter';
import { isNAPrepaySelector } from 'selectors/reservationFlowSelectors';
import { isCustomPathReservationSelector } from 'selectors/customPathCheckInSelectors';
import SKIP_THE_COUNTER from 'constants/skipTheCounter';

const { STC_ORIGINS_WITH_STEP_COUNT } = SKIP_THE_COUNTER;

// Returns the skip the counter origin if it was provided
export const getSkipTheCounterOrigin = (state) => state.getIn(skipTheCounterOriginPath);

export const getBranchLocalAddenda = (state) => state.getIn(pickupLocationLocalAddendaPath);

// Selector that parses the current step config based on the stc origin + current step hash
export const stepConfigSelector = (state) => {
  const stcOrigin = getSkipTheCounterOrigin(state);
  const isNAPrepay = isNAPrepaySelector(state);
  const isCustomPathReservation = isCustomPathReservationSelector(state);
  // We want to take the hash, but remove the initial character, so it matches the format `/step`
  const currentStepHash = utils.url.getCurrentPageHash();
  const currentStepContent = utils.skipTheCounter.getSkipTheCounterStepsContent(
    currentStepHash,
    isNAPrepay,
    isCustomPathReservation
  );
  // Step counter info is only present if STC flow origin is unset or matching a value in STC_ORIGINS_WITH_STEP_COUNT
  const currentStepCounter =
    (!stcOrigin || STC_ORIGINS_WITH_STEP_COUNT.includes(stcOrigin)) &&
    utils.skipTheCounter.parseSkipTheCounterStepCounter(currentStepHash);

  return { ...currentStepContent, currentStepCounter, stcOrigin };
};

export const branchLocalAddendaSelector = createSelector([getBranchLocalAddenda], (localAddendum) =>
  utils.safeToJS(localAddendum)
);
